import type { SVGProps } from "react";
const SvgIconDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M677.18 494.32c-9.76-9.76-25.59-9.76-35.36 0L537 599.14V217c0-13.81-11.19-25-25-25s-25 11.19-25 25v382.14L382.18 494.32c-9.76-9.76-25.59-9.76-35.36 0s-9.76 25.59 0 35.36l147.5 147.5c4.88 4.88 11.28 7.32 17.68 7.32s12.8-2.44 17.68-7.32l147.5-147.5c9.76-9.76 9.76-25.59 0-35.36" />
    <path d="M807 832H217c-13.81 0-25-11.19-25-25V659.5c0-13.81 11.19-25 25-25s25 11.19 25 25V782h540V659.5c0-13.81 11.19-25 25-25s25 11.19 25 25V807c0 13.81-11.19 25-25 25" />
  </svg>
);
export default SvgIconDownload;
